import MyScheduleList from '@/views/mySchedule/MyScheduleList'
import HdSchedule from '@/views/mySchedule/HdSchedule'
import MyScheduleReg from '@/views/mySchedule/MyScheduleReg'
import MyScheduleView from '@/views/mySchedule/MyScheduleView'
import MyOrgList from '@/views/mySchedule/MyOrgList'
import UserScheduleList from '@/views/mySchedule/UserScheduleList'

export default [
  {
      path: '/mySchedule/myScheduleList',
      name: 'my-schedule-list',
      component: MyScheduleList,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '내 일정', // 로깅 시 사용할 페이지명
      }
  },
  {
      path: '/mySchedule/hdSchedule',
      name: 'hd-schedule',
      component: HdSchedule,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '본사일정', // 로깅 시 사용할 페이지명
      }
  },
  {
      path: '/mySchedule/myScheduleReg/:sqno?',
      name: 'my-schedule-reg',
      component: MyScheduleReg,
      props: true,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          path: '/mySchedule/myScheduleReg',
          pageName: '일정등록', // 로깅 시 사용할 페이지명
      }
  },
  {
      path: '/mySchedule/myScheduleView/:sqno?',
      name: 'my-schedule-view',
      component: MyScheduleView,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          path: '/mySchedule/myScheduleView',
          pageName: '일정상세', // 로깅 시 사용할 페이지명
      }
  },
  {
      path: '/mySchedule/orgList/:username?',
      name: 'user-org-list',
      component: MyOrgList,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          path: '/mySchedule/orgList',
          pageName: '조직조회팝업', // 로깅 시 사용할 페이지명
      }
  },
  {
      path: '/mySchedule/userScheduleList/:userid?',
      name: 'user-schedule-list',
      component: UserScheduleList,
      meta: {
          auth: true,
          logging: true, // 로깅 여부
          path: '/mySchedule/userScheduleList',
          pageName: '일정조회팝업', // 로깅 시 사용할 페이지명
      }
  }
]